import React from "react"
import clsx from "clsx"
import * as styles from "./columns-list.module.css"

const deepValue = (obj, path) => path.split(".").reduce((o, tok) => o && o[tok], obj)

const isOnlyLinks = (nodes) =>
  [].concat(nodes).every((n) => {
    const singleChild = deepValue(n, "props.children.props")
    return singleChild && (singleChild.mdxType === "a" || "to" in singleChild)
  })

export default ({ children, ...props }) => {
  const cols =
    props.maxCols ||
    (props.ordered === true || !children.length || children.length < 3 || !isOnlyLinks(children) ? 1 : 2)
  const className = clsx({
    [styles.columnList2]: cols === 2,
    [styles.columnList1]: cols !== 2,
  })
  return props.ordered ? <ol className={className}>{children}</ol> : <ul className={className}>{children}</ul>
}
